// import React from 'react'
import { useNavigate } from 'react-router-dom'

// Components
import { Button } from '../../components/Button/Button'
import { Rectangle } from '../../components/Rectangle/Rectangle'
import { AnimatedScreenWrapper } from '../../components/AnimatedScreenWrapper/AnimatedScreenWrapper'

// Icons
import { Logo, AngleRight } from '../../assets'

// Styles
import './welcome.scss'

export interface WelcomeScreenProps {}

export const WelcomeScreen = (props: WelcomeScreenProps) => {
  const {} = props
  let navigate = useNavigate()

  const onHandleSubmit = () => {
    navigate('/email')
  }

  return (
    <div className="full-screen welcome-bg">
      <AnimatedScreenWrapper>
        <div className="grid">
          <div>
            <Logo />
          </div>
          <Rectangle>
            <h5 className="main-title">
              Introduce yourself <br /> to Presence
            </h5>

            <p className="description-thin">
              Let’s begin by creating <br /> your account
            </p>

            <Button onClick={onHandleSubmit}>
              create account <AngleRight />
            </Button>
            <p className="log-in">
              Already have an account? <button onClick={onHandleSubmit}>Log In</button>
            </p>
          </Rectangle>
        </div>
      </AnimatedScreenWrapper>
    </div>
  )
}
